import { keyframes } from "tss-react";
import { makeStyles } from "tss-react/mui";

import { darken } from "@mui/material";
import { Theme } from "@mui/material/styles";

const rowPulse = keyframes({
    "0%": { backgroundColor: "transparent", animationTimingFunction: "ease-out" },
    "12%": { backgroundColor: "var(--pulse-color)", animationTimingFunction: "ease-in-out" },
    "100%": { backgroundColor: "transparent" },
});

export const useBuildsTableStyles = makeStyles()((theme: Theme) => ({
    pulseRow: {
        "--pulse-color": darken(theme.palette.emteria.background.listHover, 0.12),
        animation: `${rowPulse} 5000ms`,
    },
}));
